import drstile1JPG from "../assets/images/drstile/drstile-website-1.jpg";
import drstile1WEBP from "../assets/images/drstile/drstile-website-1.webp";
import drstile2JPG from "../assets/images/drstile/drstile-website-2.jpg";
import drstile2WEBP from "../assets/images/drstile/drstile-website-2.webp";
import drstile3JPG from "../assets/images/drstile/drstile-website-3.jpg";
import drstile3WEBP from "../assets/images/drstile/drstile-website-3.webp";
import drstile4JPG from "../assets/images/drstile/drstile-website-4.jpg";
import drstile4WEBP from "../assets/images/drstile/drstile-website-4.webp";

import doublemoon1JPG from "../assets/images/double-moon/double-moon-1.jpg";
import doublemoon1WEBP from "../assets/images/double-moon/double-moon-1.webp";
import doublemoon2JPG from "../assets/images/double-moon/double-moon-2.jpg";
import doublemoon2WEBP from "../assets/images/double-moon/double-moon-2.webp";
import doublemoon3JPG from "../assets/images/double-moon/double-moon-3.jpg";
import doublemoon3WEBP from "../assets/images/double-moon/double-moon-3.webp";

const websites = {
  drstile: [
    {
      id: 1,
      src: drstile1JPG,
      srcsetWebp: drstile1WEBP,
      caption: "Dr. Style Image 1",
    },
    {
      id: 2,
      src: drstile2JPG,
      srcsetWebp: drstile2WEBP,
      caption: "Dr. Style Image 2",
    },
    {
      id: 3,
      src: drstile3JPG,
      srcsetWebp: drstile3WEBP,
      caption: "Dr. Style Image 3",
    },
    {
      id: 4,
      src: drstile4JPG,
      srcsetWebp: drstile4WEBP,
      caption: "Dr. Style Image 4",
    },
  ],

  doublemoon: [
    {
      id: 5,
      src: doublemoon1JPG,
      srcsetWebp: doublemoon1WEBP,
      caption: "Double Moon 1",
    },
    {
      id: 6,
      src: doublemoon2JPG,
      srcsetWebp: doublemoon2WEBP,
      caption: "Double Moon 2",
    },
    {
      id: 7,
      src: doublemoon3JPG,
      srcsetWebp: doublemoon3WEBP,
      caption: "Double Moon 3",
    },
  ],
};

export default websites;
